import { prefix } from '@goldwasserexchange/react-topmodel';
export var tablePrefixer = prefix('Table');
